import React, { Component } from "react";

class IssueModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      patientId: props.bag?.patient_id || "",
      issueDate: new Date().toISOString().split("T")[0],
      saving: false,
      error: "",
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const { patientId, issueDate } = this.state;

    if (!issueDate) return this.setState({ error: "Issue date is required." });

    this.setState({ saving: true, error: "" });

    fetch(`${process.env.REACT_APP_API_BASE_URL}/api/blood-issues`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        donation_id: this.props.bag.id,
        patient_id: patientId.trim() || null,
        issue_date: issueDate,
      }),
    })
      .then((res) => res.json().then((data) => ({ ok: res.ok, data })))
      .then(({ ok, data }) => {
  this.setState({ saving: false });
  if (ok) {
    if (data.whatsapp_link) {
      window.open(data.whatsapp_link, "_blank");
    }
    this.props.onIssued(data.message || "Bag issued successfully.");
  } else {
    this.setState({ error: data.message || "Failed to issue bag." });
  }
})
      .catch(() => this.setState({ saving: false, error: "Network error." }));
  };

  render() {
    const { bag, onClose } = this.props;
    const { patientId, issueDate, saving, error } = this.state;

    // Same shelf-life calculation used in the donations table
    const donationDate = new Date(bag.donation_date);
    const today = new Date();
    const totalDays = Number(bag.shelf_life_days) || 35;
    const usedDays = Math.floor((today - donationDate) / (1000 * 60 * 60 * 24));
    const remainingDays = Math.max(0, totalDays - usedDays);

    return (
      <div
        style={{
          position: "fixed", inset: 0, zIndex: 2000,
          background: "rgba(0,0,0,0.45)",
          display: "flex", alignItems: "center", justifyContent: "center",
          padding: 16,
        }}
        onClick={onClose}
      >
        <div
          style={{
            background: "#fff", borderRadius: 12,
            width: "100%", maxWidth: 420,
            boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
            overflow: "hidden",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <div style={{
            padding: "16px 20px", borderBottom: "1px solid #f0f0f0",
            display: "flex", justifyContent: "space-between", alignItems: "center",
          }}>
            <h6 style={{ margin: 0, fontWeight: 700 }}>
              <i className="bi bi-clipboard2-pulse me-2 text-danger" />
              Issue Blood Bag
            </h6>
            <button
              onClick={onClose}
              style={{ background: "none", border: "none", fontSize: 20, cursor: "pointer", color: "#888" }}
            >×</button>
          </div>

          <form onSubmit={this.handleSubmit}>
            <div style={{ padding: 20 }} className="d-flex flex-column gap-3">

              {error && (
                <div className="alert alert-danger py-2 small mb-0">{error}</div>
              )}

              {/* Auto-filled bag info */}
              <div className="p-2" style={{ background: "#f7f8fa", borderRadius: 8 }}>
                <div className="d-flex justify-content-between small">
                  <span className="text-muted">Donor</span>
                  <span className="fw-semibold">{bag.donor_name} ({bag.donor_code || `#${bag.donor_id}`})</span>
                </div>
                <div className="d-flex justify-content-between small mt-1">
                  <span className="text-muted">Bag Blood Group</span>
                  <span className="fw-semibold">{bag.blood_group}</span>
                </div>
                <div className="d-flex justify-content-between small mt-1">
                  <span className="text-muted">Patient ID</span>
                  <span className="fw-semibold">{patientId || "—"}</span>
                </div>
                <div className="d-flex justify-content-between small mt-1">
                  <span className="text-muted">Shelf Life</span>
                  <span className="fw-semibold">{remainingDays} day{remainingDays === 1 ? "" : "s"} left ({bag.status})</span>
                </div>
              </div>

              <div>
                <label className="form-label fw-semibold small mb-1">Issue Date *</label>
                <input
                  type="date" className="form-control" autoFocus
                  value={issueDate}
                  onChange={(e) => this.setState({ issueDate: e.target.value })}
                />
              </div>
            </div>

            <div style={{
              padding: "12px 20px", borderTop: "1px solid #f0f0f0",
              display: "flex", justifyContent: "flex-end", gap: 10,
            }}>
              <button type="button" onClick={onClose} disabled={saving}
                style={{ padding: "8px 18px", borderRadius: 8, border: "1px solid #ddd", background: "#f8f9fa", fontWeight: 600, cursor: "pointer" }}>
                Cancel
              </button>
              <button type="submit" disabled={saving}
                style={{ padding: "8px 20px", borderRadius: 8, border: "none", background: "#c9140e", color: "#fff", fontWeight: 600, cursor: "pointer", minWidth: 100 }}>
                {saving ? <span className="spinner-border spinner-border-sm" /> : "Issue Bag"}
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default IssueModal;
